import { useState } from 'react';
import { Switch } from '@arco-design/web-react';
// import { useSelector } from 'react-redux';
// import { RootState } from '@/store';
// import { updateShowSubtitle } from '@/store/slices/room'; // 已移除
import styles from './index.module.less';

function Subtitle() {
  // const dispatch = useDispatch(); // 暂时不使用
  // const room = useSelector((state: RootState) => state.room); // 暂时不使用
  const [checked, setChecked] = useState(true); // 默认显示字幕
  const [loading, setLoading] = useState(false);
  const handleChange = () => {
    setLoading(true);
    setChecked(!checked);
    // dispatch(updateShowSubtitle({ isShowSubtitle: !checked })); // 功能已移除
    setLoading(false);
  };
  return (
    <div className={styles.subtitle}>
      <div className={styles.label}>字幕</div>
      <div className={styles.value}>
        <Switch size="small" loading={loading} checked={checked} onChange={handleChange} />
      </div>
    </div>
  );
}

export default Subtitle;
